/**
 * @file 支付价格确认
 * @description 支付价格确认 hook
 */
import {useMutation} from '@tanstack/react-query';
import {checkPaymentPrice} from '@/services/commerce/payment';
import type {PaymentCheckReqParams} from '@/services/commerce/entities/payment';
import message from '@/components/common/Message';
import {RequestError} from '@/services/request/errors';

export const usePaymentCheck = () => {
    return useMutation({
        mutationFn: (params: PaymentCheckReqParams) => {
            return checkPaymentPrice(params)
                .then((res) => {
                    if (!res.pass) {
                        // toast提示
                        message.error('页面停留较久，价格已按最新时间更新，请确认后再提交');
                    }
                    return res;
                })
                .catch((err: unknown) => {
                    console.error('paymentCheck failed:', err);
                    if (err instanceof RequestError) {
                        message.error(err.message || '价格校验失败');
                    }
                    throw err;
                });
        },
    });
};
